import { createFileRoute, redirect } from "@tanstack/react-router";
import { homePath } from "../../app/home";

export const Route = createFileRoute("/_authed/$org/$project/")({
  beforeLoad: ({ params }) => {
    throw redirect({ href: homePath(params.org, params.project) });
  },
});
